import { render, staticRenderFns } from "./BaseH1.vue?vue&type=template&id=dbe28c18&scoped=true"
import script from "./BaseH1.vue?vue&type=script&lang=js"
export * from "./BaseH1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbe28c18",
  null
  
)

export default component.exports